<template>
  <base-slide-over ref="slideover" @hiding="reset()" title="Edit Activity" size="lg">
    <base-form ref="form" v-model="isFormValid" class="tw-py-2.5 tw-px-4 sm:tw-py-4 sm:tw-px-6">
      <!-- Readonly Activity Type -->
      <!-- <div class="tw-mb-4">
        <label class="tw-text-xs tw-font-normal tw-text-gray-900 tw-ml-3">Activity Type</label>
        <div class="tw-text-sm tw-font-light tw-text-gray-700 tw-w-full tw-flex">
          <span class="tw-my-auto tw-ml-3">{{ activityTypeLabel }}</span>
        </div>
      </div> -->

      <!-- Readonly Member -->
      <!-- <div class="tw-mb-4">
        <label class="tw-text-xs tw-font-normal tw-text-gray-900 tw-ml-3">Member</label>
        <div class="tw-text-sm tw-font-light tw-text-gray-700 tw-w-full tw-flex">
          <span class="tw-my-auto tw-ml-3">{{ memberName }}</span>
        </div>
      </div> -->

      <!-- Prescription editable select -->
      <base-select
        label="Prescription"
        :disabled="isPrescriptionsLoading"
        :options="prescriptions"
        v-model="selectedPrescriptionId"
        placeholder="Select a prescription"
        label-key="name"
        value-key="id"
        class="tw-my-5"
      />

      <!-- Plan editable select -->
      <base-select
        :label="capitalize(this.organization.customerLabelSingular) + ' plan'"
        :disabled="isPlansLoading"
        :options="plans"
        v-model="selectedPlanId"
        placeholder="Select a plan"
        label-key="planName"
        value-key="userBusinessPlanId"
        class="tw-my-5"
      />

      <!-- Readonly Due Date -->
      <!-- <div class="tw-mb-4">
        <label class="tw-text-xs tw-font-normal tw-text-gray-900 tw-ml-3">Due Date</label>
        <div class="tw-text-sm tw-font-light tw-text-gray-700 tw-w-full tw-flex">
          <span class="tw-my-auto tw-ml-3">{{ formattedDueDate }}</span>
        </div>
      </div> -->
    </base-form>

    <template #fixed-bottom>
      <inline-error class="tw-my-3" id="edit-activity-error" :title="errorTitle" :message="errorMessage" :error="error" />
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-p-3">
        <base-button @click="save" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3" :disabled="!isFormValid">Update</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">Cancel</base-button>
      </div>
    </template>
  </base-slide-over>
</template>

<script>
import InlineError from "@/components/InlineError";
import { mapGetters } from "vuex";
import { capitalize } from "lodash";
import moment from "moment";

export default {
  name: "EditTodoItem",
  components: { InlineError },
  props: {
    businessId: String,
  },
  data() {
    return {
      todoItem: null,
      activityTypeLabel: "",
      memberName: "",
      dueDate: null,
      prescriptions: [],
      isPrescriptionsLoading: false,
      selectedPrescriptionId: null,
      plans: [],
      isPlansLoading: false,
      selectedPlanId: null,
      isLoading: false,
      isFormValid: true,
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  computed: {
    ...mapGetters("organization", ["organization"]),
    formattedDueDate() {
      return this.dueDate ? moment(this.dueDate).format("MM/DD/YYYY") : "";
    },
  },
  methods: {
    capitalize,
    async show(todoItem) {
      this.reset();
      this.todoItem = todoItem;
      this.activityTypeLabel = todoItem.todoItemTypeLabel;
      this.memberName = todoItem.userName;
      this.dueDate = todoItem.dueDate ? moment(todoItem.dueDate).toDate() : null;

      this.$refs.slideover.show();

      // Load prescription & plans filtered by userId
      await this.loadPrescriptions(todoItem.userId);
      await this.loadPlans(todoItem.userId);

      // Prefill selected prescription and plan
      this.selectedPrescriptionId = todoItem.businessPrescriptionId;
      this.selectedPlanId = todoItem.userBusinessPlanId;
    },
    async loadPrescriptions(userId) {
      if (!userId) {
        this.prescriptions = [];
        return;
      }
      this.isPrescriptionsLoading = true;
      try {
        const res = await this.$axios.get(`/businesses/${this.businessId}/members/${userId}/prescriptions`);
        this.prescriptions = Array.isArray(res.data)
          ? res.data.map((p) => ({
              id: p.id,
              name: p.businessProgram ? p.businessProgram.name : "Unknown Prescription",
            }))
          : [];
      } catch {
        this.prescriptions = [];
      } finally {
        this.isPrescriptionsLoading = false;
      }
    },
    async loadPlans(userId) {
      if (!userId) {
        this.plans = [];
        return;
      }
      this.isPlansLoading = true;
      try {
        const res = await this.$axios.get(`/businesses/${this.businessId}/members/${userId}/memberplans`);
        this.plans = Array.isArray(res.data)
          ? res.data.map((p) => ({
              userBusinessPlanId: p.userBusinessPlanId,
              planName: p.planName,
            }))
          : [];
      } catch {
        this.plans = [];
      } finally {
        this.isPlansLoading = false;
      }
    },
    async save() {
      this.errorTitle = "";
      this.errorMessage = "";

      if (!this.selectedPrescriptionId && !this.selectedPlanId) {
        this.errorTitle = "Validation Error";
        this.errorMessage = "Please select a prescription or a plan.";
        return;
      }

      this.isLoading = true;
      try {
        await this.$axios.put(`/businesses/${this.businessId}/todo/${this.todoItem.todoItemId}`, {
          businessPrescriptionId: this.selectedPrescriptionId,
          userBusinessPlanId: this.selectedPlanId,
        });
        this.EventBus.$emit("activitiesUpdated", {}); // Trigger list reload
        this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Activity updated", message: "Your activity was updated." });
        this.hide();
      } catch (err) {
        this.errorTitle = "Error";
        this.errorMessage = "Failed to update activity. Please try again.";
        this.error = err;
      } finally {
        this.isLoading = false;
      }
    },
    reset() {
      this.todoItem = null;
      this.activityTypeLabel = "";
      this.memberName = "";
      this.dueDate = null;
      this.prescriptions = [];
      this.selectedPrescriptionId = null;
      this.plans = [];
      this.selectedPlanId = null;
      this.errorTitle = "";
      this.errorMessage = "";
      this.error = null;
    },
    hide() {
      this.$refs.slideover.hide();
      this.reset();
    },
  },
};
</script>
